import { Message } from 'components/message'

export class ModalAvisemeObserver {
    constructor () {
        this.modal = document.querySelector('.modal-aviseme')
    }

    next(res) {
        this.modal.classList.add('modal-aviseme--success')
    }

    error(error) {
        const msg = (error.status && error.status == 404) ?  "Não foi possível enviar o email" : error.data.mensagem
        new Message(msg)
    }

    complete() {}
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-aviseme/modal-aviseme.observer.js